module.exports = __webpack_public_path__ + "img/logo.5750c0e9.svg";